import React from "react";
import NotFound from "../Screens/Common/NotFound";
import Home from "../Screens/User/Home";
import About from "../Screens/User/About";
import Contact from "../Screens/User/Contact";
import Services from "../Screens/User/Services";
import Blogs from "../Screens/User/Blogs";
import AllProducts from "../Components/Home/AllProducts";
import CategoryWiseProduct from "../Components/Category/CategoryWiseProduct";
import Productdetails from "../Components/Products/Productdetails";
import SignIn from "../Screens/Auth/SignIn";
import AllCartProduct from "../Components/Cart/AllCartProduct";
import Address from "../Components/Addresses/Address";
import Wishlist from "../Components/WishList/Wishlist";
import AllOrders from "../Components/Order/AllOrders";
import OrderDetails from "../Components/Order/OrderDetails";
import MyProfile from "../Components/Profile/MyProfile";
import Register from "../Components/Profile/Register";
import Comparision from "../Components/Home/Comparision";
import PrivacyPolicy from "../Components/Privacy/PrivacyPolicy";
import TermsAndCondition from "../Components/Privacy/TermsAndCondition";
import DisplayHouse from "../Components/DisplayHouse/DisplayHouse";
import AllGuide from "../Components/BuyingGuide/AllGuide";
import Guidedetails from "../Components/BuyingGuide/Guidedetails";
import Careers from "../Components/Careers/Careers";


const userRoutes = [
  { path: "/", component: <Home /> },
  { path: "/about", component: <About /> },
  { path: "/contact", component: <Contact /> },
  { path: "/services", component: <Services /> },
  { path: "/blogs", component: <Blogs /> },
  { path: "/products", component: <AllProducts /> },
  { path: "/allcategories/:categoryId", component: <CategoryWiseProduct /> },
  { path: "/product-details/:productId", component: <Productdetails /> },
  { path: "/guide-details/:guideId", component: <Guidedetails /> },
  { path: "/sign-in", component: <SignIn /> },
  { path: "/wishlist", component: <Wishlist /> },
  { path: "/comparision", component: <Comparision /> },
  { path: "/all-cart-product", component: <AllCartProduct /> },
  { path: "/addresses", component: <Address /> },
  { path: "/orders", component: <AllOrders /> },
  { path: "/profile", component: <MyProfile /> },
  { path: "/register", component: <Register /> },
  { path: "/buying-guide", component: <AllGuide /> },
  { path: "/orders/:orderId", component: <OrderDetails /> },
  { path: "*", component: <NotFound /> },
  { path: "/privacy", component: <PrivacyPolicy /> },
  { path: "/career", component: <Careers /> },
  { path: "/display-house", component: <DisplayHouse /> },
  { path: "/terms-and-condition", component: <TermsAndCondition /> },
];

export { userRoutes };
